import GnbPopupMenuContainer from './GnbPopupMenuContainer';

export default GnbPopupMenuContainer;
